import { render, staticRenderFns } from "./OrdinanceInfo.vue?vue&type=template&id=4473a7b5&scoped=true&"
import script from "./OrdinanceInfo.vue?vue&type=script&lang=ts&"
export * from "./OrdinanceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrdinanceInfo.vue?vue&type=style&index=0&id=4473a7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473a7b5",
  null
  
)

export default component.exports